import React from "react";
import { Link } from "react-router-dom";
import MaintenanceBreakdownContainer from "./maintenanceBreakdown.module.css";
import SwapHorizontalCircleIcon from "@material-ui/icons/SwapHorizontalCircle";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";
import { StarOutlineSharp } from "@material-ui/icons";
import BuildIcon from "@material-ui/icons/Build";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import Spellcheck from "@material-ui/icons/Spellcheck";

const MaintenanceBreakdown = () => {
  return (
    <section style={{ height: "90vh" }}>
      <div className="divflex" style={{ fontSize: "24px" }}>
        MAINTENANCE BREAKDOWN
      </div>
      <main
        className={`${MaintenanceBreakdownContainer.container} ${MaintenanceBreakdownContainer.main}`}
      >
        <div>
          <Link
            to="/maintenance_breakdown/maintenance?documentType=preventive"
            className="panel"
          >
            <BuildIcon style={{ fontSize: "3rem", color: "maroon" }} />
          </Link>
          <p className="card-btn-para">
            PREVENTIVE MAINTENANCE
            <span className="card-btn-span">PLAN</span>
          </p>
        </div>
        <div>
          <Link
            to="/checklist_actions_list?documentType=preventive"
            className="panel"
          >
            <Spellcheck style={{ fontSize: "3rem", color: "#003566" }} />
          </Link>
          <p className="card-btn-para">
            PREVENTIVE MAINTENANCE
            <span className="card-btn-span">STATUS</span>
          </p>
        </div>
        <div>
          <Link
            to="/maintenance_breakdown/maintenance?documentType=predictive"
            className="panel"
          >
            <BuildIcon style={{ fontSize: "3rem", color: "maroon" }} />
          </Link>
          <p className="card-btn-para">
            PREDICTIVE MAINTENANCE
            <span className="card-btn-span">PLAN</span>
          </p>
        </div>
        <div>
          <Link
            to="/checklist_actions_list?documentType=predictive"
            className="panel"
          >
            <Spellcheck style={{ fontSize: "3rem", color: "#003566" }} />
          </Link>
          <p className="card-btn-para">
            PREDICTIVE MAINTENANCE
            <span className="card-btn-span">STATUS</span>
          </p>
        </div>
        {/* <div> */}
        {/*   <Link to="/breakdown_logs/maintenance" className="panel"> */}
        {/*     <SmsFailedIcon style={{ fontSize: "3rem", color: "maroon" }} /> */}
        {/*   </Link> */}
        {/*   <p className="card-btn-para"> */}
        {/*     BREAKDOWN <span className="card-btn-span">Register</span> */}
        {/*   </p> */}
        {/* </div> */}
      </main>
    </section>
  );
};

export default MaintenanceBreakdown;
